module.exports = __webpack_public_path__ + "static/favicon-96x96-613acf6c6e4407f1de7688c4a1fe10d8.png";